import React from "react"
import "style.css"
import "tailwindcss/lib/css/preflight.css"
import Nav from "components/clarebrand/Nav"
import Hero from "components/clarebrand/Landing"
// Events are on hold for now — re-enable by uncommenting the import and <UpcomingDates /> below
// import UpcomingDates from "components/clarebrand/UpcomingDates"
import Services from "components/clarebrand/Services"
import Contact from "components/clarebrand/ContactUs"
import PrivacyInfo from "components/clarebrand/Privacy"
import TermsInfo from "components/clarebrand/Terms"
import Footer from "components/clarebrand/Footer"
import CookieConsent from "react-cookie-consent"

const ConsentButtonText = 'OK'
const ConsentText = 'This website uses cookies to enhance the user experience. '
const ConsentStyle = { background: "#060F0C" }
const ConsentButtonStyle = { color: "#060F0C", background: "#FAF9F9", fontSize: "13px" }

function App() {
  switch(window.location.pathname ) {
    case '/book':
      return <ContactSingle />
    case '/services':
      return <ServiceSingle />
    case '/privacy':
      return <PrivacyPolicy />
    case '/terms':
      return <TermsOfServicePage />
    default:
      return <Home />
  }
}

function Home() {
  return (
    <div>
      <CookieConsent
        location="bottom"
        buttonText={ConsentButtonText}
        cookieName="myAwesomeCookieName2"
        style={ConsentStyle}
        buttonStyle={ConsentButtonStyle}
        expires={150}
      >
        {ConsentText}
      </CookieConsent>
      <Hero />
      {/* <UpcomingDates /> */}
      <Services />
      <Contact />
      <Footer />

    </div>
  )
}

function PrivacyPolicy() {
  return (
    <div>
      <CookieConsent
        location="bottom"
        buttonText={ConsentButtonText}
        cookieName="myAwesomeCookieName2"
        style={ConsentStyle}
        buttonStyle={ConsentButtonStyle}
        expires={150}
      >
        {ConsentText}
      </CookieConsent>
      <Nav />
      <PrivacyInfo />
      <Footer />

    </div>
  )
}

function TermsOfServicePage() {
  return (
    <div>
      <CookieConsent
        location="bottom"
        buttonText={ConsentButtonText}
        cookieName="myAwesomeCookieName2"
        style={ConsentStyle}
        buttonStyle={ConsentButtonStyle}
        expires={150}
      >
        {ConsentText}
      </CookieConsent>
      <Nav />
      <TermsInfo />
      <Footer />

    </div>
  )
}

function ContactSingle() {
  return (
    <div>
      <CookieConsent
        location="bottom"
        buttonText={ConsentButtonText}
        cookieName="myAwesomeCookieName2"
        style={ConsentStyle}
        buttonStyle={ConsentButtonStyle}
        expires={150}
      >
        {ConsentText}
      </CookieConsent>
      <Nav />
      <Contact />
      <Footer />

    </div>
  )
}

function ServiceSingle() {
  return (
    <div>
      <CookieConsent
        location="bottom"
        buttonText={ConsentButtonText}
        cookieName="myAwesomeCookieName2"
        style={ConsentStyle}
        buttonStyle={ConsentButtonStyle}
        expires={150}
      >
        {ConsentText}
      </CookieConsent>
      <Nav />
      <Services />
      <Footer />

    </div>
  )
}

export default App
